import * as React from 'react';
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import DialogContent from "@mui/material/DialogContent";
import {styled} from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';

const BootstrapDialog = styled(Dialog)(({theme}) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

type requestFormProps = {
    tooHeavy: boolean,
    setTooHeavy: React.Dispatch<React.SetStateAction<boolean>>

};

export const TooHeavy = ({
                             tooHeavy,
                             setTooHeavy
                         }: requestFormProps) => {
    const [open, setOpen] = React.useState(false);
    const [openAfter, setAfterOpen] = React.useState(false);

    const handleClose = () => {
        setOpen(false);
        setAfterOpen(false);
        setTooHeavy(false);
    };

    React.useEffect(() => {
        if (tooHeavy) {
            setOpen(true);
        }
    }, [tooHeavy]);

    return (
        <>
            <BootstrapDialog
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={open}
                maxWidth={'md'}
            >
                <DialogTitle sx={{m: 0, p: 2, mr: 5}} id="customized-dialog-title">
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon/>
                </IconButton>
                <DialogContent dividers>
                    <h2>Rekomenduojame konteinerį</h2>
                    <p>Aptikome didelį kiekį sunkių statybinių atliekų.
                        Tokį kiekį patogiausia ir ekonomiškiausia išvežti konteineriu.</p>
                </DialogContent>
                <DialogContent>
                    <div className="too-heavy-actions">
                        <a href={'https://konteinerionuoma.lt/'} target={"_blank"} rel="noopener noreferrer"
                           className={"primary-btn btn"}>
                            🚛 Užsakyti konteinerį
                        </a>
                        <a href={'tel:+370 630 00085'} className={"primary-btn btn"}>
                            📞 +370 630 00085
                        </a>
                    </div>
                </DialogContent>
            </BootstrapDialog>
        </>
    );
}
